// extracted by css-extract-rspack-plugin
export default {"cls1":"download_preflight-cls1_DJw","cls2":"download_preflight-cls2_Nk4 download_preflight-cls1_DJw"};